<template>
  <validation-observer ref="provider-fisical-direction-form">
    <div class="mb-5">
      <section-title title="Información de Dirección Física" />

      <div class="row mb-4 pl-3">
        <div class="col-sm">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-input
              v-model="model.addressOne"
              :custom-error-msg="validationMessages.required"
              :error="errors[0]"
              label="Dirección (Línea 1):"
            />
          </validation-provider>
        </div>
        <div class="col-sm">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="model.municipality"
              :custom-error-msg="validationMessages.select"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Municipio:"
              :options="municipalities"
              placeholder="Seleccione"
            />
          </validation-provider>
        </div>
        <div class="col-sm">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-input
              v-model="model.zipCode"
              :custom-error-msg="validationMessages.required"
              :error="errors[0]"
              label="Código Postal:"
              mask-type="ZipcodeExt"
              placeholder="_____-____"
            />
          </validation-provider>
        </div>
      </div>

      <div class="row mb-4 pl-3">
        <div class="col-sm">
          <custom-input
            v-model="model.addressTwo"
            label="Dirección (Línea 2):"
          />
        </div>
        <div class="col-sm">
          <validation-provider
            v-slot="{ errors }"
            :rules="{ regex: /(-?\d+(\.\d+)?)/ }"
          >
            <custom-input
              v-model="model.gpsLatitudee"
              :custom-error-msg="validationMessages.invalidCoordinate"
              :error="errors[0]"
              label="Latitud:"
              placeholder="____._________"
            />
          </validation-provider>
        </div>
        <div class="col-sm">
          <validation-provider
            v-slot="{ errors }"
            :rules="{ regex: /(-?\d+(\.\d+)?)/ }"
          >
            <custom-input
              v-model="model.gpsLongitude"
              :custom-error-msg="validationMessages.invalidCoordinate"
              :error="errors[0]"
              label="Longitud:"
              placeholder="____._________"
            />
          </validation-provider>
        </div>
      </div>

      <div class="row mb-4 pl-3">
        <div class="col-sm-12 col-md-4">
          <custom-input
            v-model="model.addressThree"
            label="Dirección (Línea 3):"
          />
        </div>
        <div class="col">
          <custom-input
            v-model="model.annotations"
            label="Anotaciones Adicionales:"
            placeholder="Escribir información adicional de cómo llegar…"
          />
        </div>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import SectionTitle from '@/components/common/page/SectionTitle';
import CustomInput from '@/components/common/form/CustomInput';
import CustomDropDown from '@/components/common/form/CustomDropDown';
import { mapActions, mapState } from 'vuex';
import { name } from '@/modules/provider/store';

export default {
  name: 'ProviderCreateFisicalDirectionForm',
  components: {
    SectionTitle,
    CustomInput,
    CustomDropDown,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    valid: {
      type: Boolean,
      default: false,
    },
    proposalInfo: {
      type: Object,
      default: () => null,
    },
  },
  data: () => ({
    model: {
      addressOne: '',
      addressTwo: '',
      addressThree: '',
      annotations: '',
      municipality: null,
      zipCode: '',
    },
    validationMessages: {
      required: 'Campo Requerido',
      select: 'Favor Seleccione',
      invalidCoordinate: 'Coordenada inválida',
      invalidForm: 'Favor de completar la información solicitada.',
      successSave: '',
    },
  }),
  watch: {
    proposalInfo: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          if (newVal) {
            this.model = {
              ...this.model,
              addressOne: newVal.physicalAddressLine1,
              municipality: newVal.physicalAddressMunicipality,
              zipCode: newVal.physicalAddressPostalCode,
            };
          }
        }
      },
    },
  },
  computed: {
    ...mapState(name, ['municipalities']),
  },
  async created() {
    await this.getMunicipalities();
  },
  methods: {
    ...mapActions(name, ['getMunicipalities']),
    async validate() {
      const valid = await this.$refs[
        'provider-fisical-direction-form'
      ].validate();

      const data = valid ? this.model : {};

      this.$emit('update:data');
      this.$emit('update:valid', valid);

      return { data, valid };
    },
    reset() {
      this.$refs['provider-fisical-direction-form'].reset();
    },
  },
};
</script>
